import angular from 'angular';

angular.module('cloudX').directive('cxStringAsEnumList', [
  function() {
    return {
      restrict: 'E',
      template:
        '<span ng-repeat="item in valueArray track by $index"> {{item | translateList: type}}<span ng-if="!$last">, </span>',
      scope: {
        value: '=',
        type: '@',
      },
      controller: [
        '$scope',
        function($scope) {
          $scope.valueArray = $scope.value
            ? $scope.value
                .replace(/\s/g, '')
                .split(',')
                .filter(x => x !== '')
            : [];
        },
      ],
    };
  },
]);
